import { Box, Button, Grid, TextField, Tooltip, Select, MenuItem, Divider, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from "react";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from '../../../utils/fvAxios';
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Papa from 'papaparse';
import { ToastContainer, toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import ErrorIcon from '@mui/icons-material/Error';
import Backdrop from "@mui/material/Backdrop";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#F2F4F7",
        color: "#101828",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function UploadEmployees() {
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const INFO = [
        {
            key: "1",
            text: "Drivers License"
        },
        {
            key: "2",
            text: "GreenCard"
        },
        {
            key: "3",
            text: "SSN"
        },
        {
            key: "4",
            text: "PhoneNumber "
        }
    ]

    const data = [{
        "firstName": "RAMU",
        "lastName": "ARA",
        "title": "CASE",
        "password": "START100",
        "Id": "Drivers License",
        "last4Digits": "9999",
        "email": "A@gmail.com"
    }];
    const headers = [
        { label: "FirstName", key: "firstName" },
        { label: "LastName", key: "lastName" },
        { label: "Title", key: "title" },
        { label: "ID", key: "id" },
        { label: "Last4DigitsOfId", key: "last4Digits" },
        { label: "Email", key: "email" },
        { label: "Password", key: "password" }
    ]

    const csvLink = {
        filename: 'Sample Bulk Employee Upload.csv',
        headers: headers,
        data: data
    }

    const [files, setFiles] = useState([]);
    const [fileData, setFileData] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [AddEmployeDisiable, setAddEmployeDisiable] = useState(false);
    const [validateerrors, setvalidateerrors] = useState([]);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleClickOpen = () => {
        setOpen(true);
        setFileData([]);
        setFiles([]);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const { t } = useTranslation();
    const activeStyle = {
        borderColor: "#2196f3",
    };

    const acceptStyle = {
        borderColor: "#00e676",
    };

    const rejectStyle = {
        borderColor: "#ff1744",
    };
    const onDrop = useCallback((acceptedFiles) => {
        setFiles(
            acceptedFiles?.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            )
        );
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        onDrop,
        accept: { 'csv': ['.csv'] },
        maxFiles: 1,
    })



    const mmmt = useMemo(
        () => ({
            ...(isDragActive ? activeStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isDragActive, isDragReject, isDragAccept]
    );

    const thumbs = files?.map((file) => <div key={file?.name}>{file?.name}</div>);
    useEffect(
        () => () => {
            files?.forEach((file) => URL.revokeObjectURL(file?.name));
        }, []
    );
    const [loader, setloader] = useState(false);
    const BulkEmployeeData = () => {
        // setErrorColor([])
        if (files == "") {
            toastNotify("Please upload file", false);
        } else {
            files?.forEach((file) => {
                const reader = new FileReader();
                reader.onload = () => {
                    const data = reader?.result;
                    const jsonData = Papa?.parse(data, { header: true });

                    if (jsonData?.data?.length > 100) {
                        toastNotify("More than 100 rows can't be uploaded", false);
                    } else {

                        const formData = new FormData();
                        formData.append("csvFile", files[0]);
                        setloader(true)
                        handleClose();
                        axios
                            .post("Employee/ValidateEmployeeData", formData
                            )
                            .then((res) => {
                                if (res?.data?.data?.errorsForUser?.length == 0) {

                                    // toast.success(res?.data?.responseMessage, {
                                    //     position: "top-right",
                                    //     autoClose: 4000,
                                    //     hideProgressBar: false,
                                    //     closeOnClick: true,
                                    //     pauseOnHover: true,
                                    //     draggable: true,
                                    //     progress: undefined,
                                    //     theme: "light",
                                    // });

                                    AddEmployes();
                                    setFiles([]);
                                } else {
                                    toast.error("Please enter valid details", {
                                        position: "top-right",
                                        autoClose: 5000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                    });
                                    setvalidateerrors(res?.data?.data?.errorsForUser)
                                    setFileData(jsonData?.data);
                                    jsonData?.data?.pop();
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                            })
                            .finally(() => {
                                setloader(false)
                            });
                    }
                };
                reader.readAsText(file);
            })
        }
    };


    const [isDownloading, setIsDownloading] = useState(false);
    //const [ErrorColor, setErrorColor] = useState([]);


    const AddEmployes = () => {
        setIsDownloading(true);


        // const isValidLast4Digits = (last4Digits) => {

        //     return /^\d{4}$/.test(last4Digits);
        // };

        // const isValidEmail = (email) => {

        //     return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        // };

        // const validationErrors = [];
        // const duplicateEmails = new Set();

        // setErrorColor(validationErrors)

        // const Employees = fileData?.map((r, index) => {
        //     const documentTypeMapping = INFO?.find((p) => p?.text === r?.DocumentType);

        //     if (!documentTypeMapping) {
        //         toastNotify(`Invalid DocumentType '${r?.DocumentType}'. Please provide a valid DocumentType.`, false);
        //         validationErrors.push(index + 1);
        //         return null;
        //     }

        //     if (!isValidLast4Digits(r?.Last4DigitsOfId) || !isValidEmail(r?.Email)) {
        //         validationErrors.push(index + 1);
        //         return null;
        //     }

        //     if (duplicateEmails.has(r?.Email)) {
        //         toastNotify(`Duplicate email address found for employee at Row ${index + 1}. Please provide unique email addresses.`, false);
        //         setIsDownloading(false);
        //         validationErrors.push(index + 1);
        //         return null;
        //     }
        //     duplicateEmails.add(r?.Email);

        //     return {
        //         "firstName": r?.FirstName,
        //         "lastName": r?.LastName,
        //         "title": r?.Title,
        //         "phoneNumber": "",
        //         "documentType": documentTypeMapping.key,
        //         "last4Digits": r?.Last4DigitsOfId,
        //         "email": r?.Email,
        //         "userHasEmail": true,
        //         "password": r?.Password
        //     };

        // }).filter(Boolean);


        // if (files[0]) {

        const formData = new FormData();
        formData.append("csvFile", files[0]);
        axios.post("Employee/BulkEmployeeInsertion", formData)
            .then((res) => {
                if (res?.data?.responseCode === 100) {
                    toastNotify(res?.data?.responseMessage, true);
                    setIsDownloading(false);
                    setFileData([]);
                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setIsDownloading(false);
                }
            })
            .catch((error) => {
                console.error("Error adding employees:", error);
                // toastNotify("An error occurred while adding employees. Please try again.", false);
                setIsDownloading(false);
            });

        // } else {
        //     // toastNotify(`Invalid data for employees at indices ${validationErrors.join(', ')}. Please provide valid details.`, false);
        //     setIsDownloading(false);

        // }
    };
    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))`
        & .MuiTooltip-tooltip {
          background:  rgba(97, 97, 97, 0.92)!important;
          color:#fff !important
        }
           & .MuiTooltip-arrow: {
          color: rgba(97, 97, 97, 0.92)!important;
        }
      `;

    return (
        <>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <ToastContainer />
            <Dialog fullScreen={fullScreen} open={open} >
                <DialogContent sx={{ width: "600px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span> Upload Employees  </span>      <span style={{ float: "right", cursor: "pointer" }} onClick={handleClose}> <CloseIcon /> </span>
                    </DialogTitle>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span> Instructions  </span>
                    </DialogTitle>
                    <ul>
                        <li><b>Last4DigitsOfId</b> - Should be exactly Four digits</li>
                        <li><b>Id</b> - Should be Either of the four items

                            <ul>
                                <li>Drivers License </li>
                                <li> Green Card</li>
                                <li>Social Security Number (SSN)</li>
                                <li>Phone Number</li>
                            </ul>
                        </li>
                        <li> <b>Email</b> - Should be unique.</li>
                    </ul>
                    <div
                        className="drop"
                        {...getRootProps({ mmmt })}
                        style={{ padding: "10px" }}
                    >
                        <input {...getInputProps()} />

                        <span className="text-muted mt-2 fs">
                            <b>
                                <span className="mx-1 cl">
                                    {t("DragandDrop.firstLabel1")}{" "}
                                    <span className=" text-muted Fs">
                                        or drag and drop
                                    </span>

                                </span>
                            </b>
                            only .csv file
                        </span>
                        <br />

                        <span className=" text-muted Fs"> {thumbs}</span>
                    </div>
                    <DialogActions >
                        <div className="login-help__buttonContainer mt-4">
                            <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                            <Button variant="contained" className="login-button-request mx-2" onClick={BulkEmployeeData} >Submit</Button>
                        </div>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Box sx={{ padding: "10px" }}>
                <p
                    style={{
                        color: "#101828",
                        fontWeight: "600",
                        fontSize: "28px",
                        marginBottom: "10px",
                    }}
                >
                    Upload Employees
                </p>
                <Box
                    borderLeft={1}
                    borderRight={1}
                    border={1}
                    borderColor="#e4e7ec"
                    sx={{ padding: "20px", backgroundColor: "#fff" }}
                >
                    <p style={{ fontSize: "16px", fontWeight: "400" }}>
                        Click button to upload list of employees (use template below)
                    </p>
                    <Button
                        variant="contained"
                        sx={{ padding: "15px", marginTop: "5px", textTransform: "capitalize" }}
                        onClick={handleClickOpen}
                        disabled={isDownloading}
                    >
                        Upload Employees
                    </Button>
                    <hr class="solid" />
                    <p style={{ fontSize: "16px", fontWeight: "400" }}>
                        Click link to get template for uploading list of employees
                    </p>
                    {/* <Button
                    variant="outlined"
                    sx={{ padding: "15px", marginTop: "5px" }}
                >
                </Button> */}
                    <CSVLink style={{ width: "auto", padding: "5px", textDecoration: "none", color: "#2A93DB", borderStyle: "solid", borderColor: "#E4E7EC", borderRadius: "2px" }}
                        {...csvLink}>Download Sample Template
                    </CSVLink>
                </Box>

                <Box
                    hidden={fileData?.length == 0}
                    borderLeft={1}
                    borderRight={1}
                    borderColor="#e4e7ec"
                    sx={{ padding: "20px", backgroundColor: "#fff", marginTop: "20px" }}
                >
                    <p style={{
                        color: "#101828",
                        fontWeight: "400",
                        fontSize: "18px",
                        marginBottom: "10px",
                    }}>Employees to Add</p>

                    <TableContainer >

                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell align="left">&nbsp;</StyledTableCell>
                                    <StyledTableCell>Name</StyledTableCell>
                                    <StyledTableCell align="left">Title</StyledTableCell>
                                    <StyledTableCell align="left">Email</StyledTableCell>
                                    <StyledTableCell align="left">Password</StyledTableCell>
                                    <StyledTableCell align="left">ID Type & ID No.&nbsp;</StyledTableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {fileData?.map((row, index) => {
                                    const email = row?.Email;
                                    const errors = validateerrors?.find(error => Object?.keys(error)[0] === email);

                                    return (
                                        <>
                                            <StyledTableRow key={index} sx={{ backgroundColor: errors ? '#ffcccc' : 'inherit' }}>
                                                <StyledTableCell component="th" scope="row">
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                                        {errors && (
                                                            <Tooltip title={errors[row?.Email]} arrow>
                                                                <ErrorIcon style={{ marginLeft: '5px', cursor: 'pointer' }} />
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row?.FirstName} {row?.LastName}

                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row?.Title}

                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row?.Email}

                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row?.Password}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {row?.ID} - {row?.Last4DigitsOfId}

                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    );
                                })}

                            </TableBody>
                        </Table>
                    </TableContainer>
                    <hr class="solid" />
                    {isDownloading ? (
                        <CircularProgress />
                    ) : (
                        <Button
                            hidden={validateerrors != []}
                            variant="contained"
                            sx={{ padding: "15px", marginTop: "5px" }}
                            onClick={AddEmployes}

                        >
                            Save
                        </Button>
                    )}

                </Box>
            </Box>
        </>
    )
}
